import Vue from 'vue'
import Vuex from 'vuex'

import version from './version'
import map from './map'
import sidebar from './sidebar'
import filters from './filters'
import geodata from './geodata'
import user from './user'
import config from './config'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    version,
    map,
    sidebar,
    filters,
    geodata,
    user,
    config
  },
  state: {
    
  },
  getters: {

  },
  mutations: {

  },
  actions: {

  }
})
